<template>
    <div class="courses-single-page bg-dark-blue">
        <div class="container p-3">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card mt-3 mb-3">
                        <div class="container-fluid">
                            <div class="content-page-wrap clearfix">
                                <div class="course-single">
                                    <div class="d-flex flex-column h-100">
                                        <div class="container mt-2">
                                            <div class="container">
                                                <div class="title text-dark-blue">
                                                    Bulk Enrollment
                                                </div>
                                                <div>
                                                    <label class="text-dark-blue">Format: Name,Surname,Email [new line]</label>
                                                    <textarea v-on:change="enrollmentChanged" v-model="bulkpaste" rows="15" />
                                                </div>
                                            </div>
                                            <div class="container">
                                                <div class="title text-dark-blue">
                                                    Add single
                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center mb-4">
                                                <div class="container">
                                                    <label class="text-dark-blue">
                                                        Name
                                                    </label>
                                                    <input type="text" name="first-name" v-model="tempName" />
                                                </div>
                                                <div class="container">
                                                    <label class="text-dark-blue">
                                                        Surname
                                                    </label>
                                                    <input type="text" name="last-name" v-model="tempSurname" />
                                                </div>
                                                <div class="container">
                                                    <label class="text-dark-blue">
                                                        Email
                                                    </label>
                                                    <input type="text" name="email" v-model="tempEmail" />
                                                </div>
                                                <div class="container d-flex justify-content-center pt-4">
                                                    <button type="button" class="btn-add-alt-2 mt-2" style="border-radius: 8px;" v-on:click="addUser">Add</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="container">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="container-fluid">
                                                    <div class="table-responsive">
                                                        <table class="table text-dark-blue">
                                                            <thead>
                                                                <tr>
                                                                    <td>#</td>
                                                                    <td>Name</td>
                                                                    <td>Surname</td>
                                                                    <td>Email</td>
                                                                    <td>Valid</td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(user, idx) in users" v-bind:class="{ 'text-danger': (!user.valid) }">
                                                                    <td>{{ idx }}</td>
                                                                    <td>{{ user.name }}</td>
                                                                    <td>{{ user.surname }}</td>
                                                                    <td>{{ user.email }}</td>
                                                                    <td>{{ user.valid }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="container">
                                        <div class="container mb-3">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="title text-dark-blue">
                                                    Course Allocations
                                                </div>
                                                <div class="site-select" v-if="userRole == 'admin'">
                                                    <select v-model="selectedSite">
                                                        <option v-for="site in sites" :value="site">{{site.name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="container">
                                            <div class="table-responsive">
                                                <table class="table text-dark-blue">
                                                    <thead>
                                                        <tr>
                                                            <th>ID</th>
                                                            <th>Site</th>
                                                            <th>Course</th>
                                                            <th>Allocated</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="course in filteredCourses">
                                                            <td>
                                                                {{ course.id }}
                                                            </td>
                                                            <td>
                                                                {{ course.siteName }}
                                                            </td>
                                                            <td>
                                                                {{ course.name }}
                                                            </td>
                                                            <td>
                                                                <input type="checkbox" v-model="course.allocated" />
                                                            </td>
                                                        </tr>
                                                        <tr v-show="filteredCourses && filteredCourses.length < 1">
                                                            <td colspan="4">
                                                                No courses for selected site
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="container d-flex justify-content-end">
                                        <button class="btn-add" v-on:click="save">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'AdminUsersBulkEnrollment',
        mixins: [],
        computed: {
        },
        data: function () {
            return {
                courses: null,
                bulkpaste: "",
                users: [],
                tempName: "",
                tempSurname: "",
                tempEmail: "",
                selectedSite: null,
                sites: null
            }
        },
        computed: {
            userRole() {
                var roles = this.$store.state.user.roles;
                return roles[0];
            },
            filteredCourses() {
                var filtered = [];
                if (this.userRole && this.courses && this.userRole == "admin") {
                    for (var i = 0; i < this.courses.length; i++) {
                        var currentCourse = this.courses[i];
                        if (currentCourse.siteId == this.selectedSite.id) {
                            filtered.push(currentCourse);
                        }
                    }
                }
                else {
                    filtered = this.course;
                }
                return filtered;
            }
        },
        methods: {
            async save() {

                var courseIds = this.courses.filter(x => x.allocated).map(x => x.id);
                await this.web('/users/EnrollBulk', "Performing bulk enrollment", {
                    users: this.users,
                    courseIds: courseIds
                });

                this.$router.replace("/admin/users");

            },
            enrollmentChanged: function enrollmentChanged() {
                this.users = [];
                var lines = this.bulkpaste.replace(/\r/, "").replace(/\t/, "").split("\n");
                for (var i = 0; i < lines.length; i++) {
                    var line = lines[i].trim();
                    if (line.length == 0)
                        continue;

                    var cols = line.split(",");
                    var user;

                    if (cols.length != 3) {
                        user = {
                            name: line,
                            surname: "",
                            email: "",
                        };
                    }
                    else {
                        user = {
                            name: cols[0].trim(),
                            surname: cols[1].trim(),
                            email: cols[2].trim()
                        };
                    }

                    var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                    user.valid = (user.email.length > 3 && re.test(user.email));

                    this.users.push(user);
                }
            },
            addUser() {
                var userString = this.tempName + ',' + this.tempSurname + ',' + this.tempEmail + "\n";
                this.resetTempFields();
                this.bulkpaste += userString;
                this.enrollmentChanged();
            },
            resetTempFields() {
                this.tempName = "";
                this.tempSurname = "";
                this.tempEmail = "";
            },
        },
        async mounted() {
            var courses = await this.web('/courses?filters=admin&filters=all', "Loading courses");
            if (this.userRole == 'admin') {
                this.sites = await this.web("/sites", "Loading sites");
                this.selectedSite = this.sites[0];
            }

            for (var i = 0; i < courses.length; i++) {
                courses[i].allocated = false;
            }

            this.courses = courses;

            var crumbs = {};
            crumbs["/admin"] = "Admin";
            crumbs["/admin/users/"] = "Users";
            crumbs["/admin/users/BulkEnrollment/"] = "Bulk Enrollment";
            this.$store.commit("breadCrumbs", crumbs);
        }
    }
</script>